module.exports = __webpack_public_path__ + "static/media/wenhua-2@2x.19cf5f3c.png";